import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Stack } from 'shared/mui/Stack/Stack';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { TransactionsReportSummary } from 'types/embedded/transactionsReportSummary';

import { LeftColCardTable, RightColCardTable } from './OrdersListSummaryDialog.styled';

type Props = {
  summary?: TransactionsReportSummary;
};

export const OrdersListSummaryDialogTable: React.FC<Props> = ({ summary }): JSX.Element => {
  const translate = useTypedTranslate();

  const {
    created,
    prepared,
    pending,
    success,
    failure,
    cancelled,
    expired,
    refund,
    chargeback,
    waitingConfirmation,
  } = summary ?? {};

  return (
    <Stack direction="row" sx={{ marginY: '24px' }}>
      <LeftColCardTable>
        <TableRowWrapper label={translate('app.statuses.created')}>{created}</TableRowWrapper>
        <TableRowWrapper label={translate('app.statuses.prepared')}>{prepared}</TableRowWrapper>
        <TableRowWrapper label={translate('app.statuses.pending')}>{pending}</TableRowWrapper>
        <TableRowWrapper label={translate('app.statuses.success')}>{success}</TableRowWrapper>
        <TableRowWrapper label={translate('app.statuses.failure')}>{failure}</TableRowWrapper>
      </LeftColCardTable>
      <RightColCardTable>
        <TableRowWrapper label={translate('app.statuses.cancelled')}>{cancelled}</TableRowWrapper>
        <TableRowWrapper label={translate('app.statuses.expired')}>{expired}</TableRowWrapper>
        <TableRowWrapper label={translate('app.statuses.refund')}>{refund}</TableRowWrapper>
        <TableRowWrapper label={translate('app.statuses.chargeback')}>{chargeback}</TableRowWrapper>
        <TableRowWrapper label={translate('app.statuses.waitingConfirmation')}>
          {waitingConfirmation}
        </TableRowWrapper>
      </RightColCardTable>
    </Stack>
  );
};
